import React from 'react';
import { ui } from '../../styles/shared';

// Stilar från den gemensamma stilfilen
const card = ui.card;
const inputStyle = ui.input;
const labelStyle = ui.label;

interface TraceForm {
    cluster: string;
    property: string;
    durationSeconds: string;
    maxEntries: string;
}

interface Props {
    traceForm: TraceForm;
    traceLoading: boolean;
    traceSession: any | null;
    traceEntries: any[];
    traceMsg: string | null;
    onFormChange: (fn: (prev: TraceForm) => TraceForm) => void;
    onStart: () => void;
    onRefresh: () => void;
    onStop: () => void;
}

const DeviceTracePanel: React.FC<Props> = ({
    traceForm, traceLoading, traceSession, traceEntries, traceMsg,
    onFormChange, onStart, onRefresh, onStop,
}) => (
    <div style={{ ...card, marginTop: '20px' }}>
        <h3 style={{ marginTop: 0 }}>Spåra enhet (felsökning)</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '10px', marginBottom: '12px' }}>
            <div>
                <label style={labelStyle}>Kluster (frivilligt)</label>
                <input type="text" value={traceForm.cluster}
                    onChange={e => onFormChange(p => ({ ...p, cluster: e.target.value }))}
                    placeholder="t.ex. genBasic" style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Egenskap (frivilligt)</label>
                <input type="text" value={traceForm.property}
                    onChange={e => onFormChange(p => ({ ...p, property: e.target.value }))}
                    placeholder="t.ex. 65282" style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Hur länge (s)</label>
                <input type="number" min="10" max="3600" value={traceForm.durationSeconds}
                    onChange={e => onFormChange(p => ({ ...p, durationSeconds: e.target.value }))}
                    style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Högst antal rader</label>
                <input type="number" min="10" max="1000" value={traceForm.maxEntries}
                    onChange={e => onFormChange(p => ({ ...p, maxEntries: e.target.value }))}
                    style={inputStyle} />
            </div>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
            <button disabled={traceLoading} onClick={onStart}
                style={{ padding: '8px 14px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                {traceLoading ? 'Arbetar…' : 'Starta spårning'}
            </button>
            <button disabled={traceLoading} onClick={onRefresh}
                style={{ padding: '8px 14px', backgroundColor: '#17a2b8', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                Uppdatera
            </button>
            <button disabled={traceLoading} onClick={onStop}
                style={{ padding: '8px 14px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                Stoppa spårning
            </button>
        </div>
        {traceMsg && <p style={{ marginTop: 0, color: traceMsg.startsWith('Fel') ? '#dc3545' : '#28a745' }}>{traceMsg}</p>}
        {traceSession && (
            <p style={{ margin: '0 0 10px 0', color: '#555', fontSize: '13px' }}>
                Pågår till: {new Date(traceSession.expiresAt).toLocaleString('sv-SE')} · rader: {traceEntries.length}
            </p>
        )}
        <pre style={{ margin: 0, maxHeight: '340px', overflow: 'auto', backgroundColor: '#f8f9fa', border: '1px solid #eee', borderRadius: '6px', padding: '10px', fontSize: '12px' }}>
{traceEntries.length > 0 ? JSON.stringify(traceEntries, null, 2) : 'Inga rader ännu.'}
        </pre>
    </div>
);

export default DeviceTracePanel;
